import type { components } from "../../api/schema";
import { cn } from "../../lib/cn";

type NoteType = components["schemas"]["NoteType"];

const BADGE_LABEL: Record<NoteType, string> = {
  trading_day: "Day note",
  trade: "Trade",
  other: "Note",
};

// The WickScope ".tl-note-badge": a tiny uppercase chip whose fill encodes the
// note type — gold for the day note, accent wash for a trade note, neutral for
// a freeform note.
export function NoteBadge({ noteType }: { noteType: NoteType }) {
  return (
    <span
      className={cn(
        "rounded-[6px] px-2 py-[3px] text-[9px] font-bold uppercase tracking-[0.06em]",
        noteType === "trading_day" && "bg-warn-border text-on-warn-soft",
        noteType === "trade" && "bg-primary-soft text-primary-hover",
        noteType === "other" && "bg-surface-container-low text-on-surface-variant",
      )}
    >
      {BADGE_LABEL[noteType]}
    </span>
  );
}
